// extracted by mini-css-extract-plugin
export var content = "Highlight-module--content--W5FkA";
export var text = "Highlight-module--text--xTazi";
export var title = "Highlight-module--title--G6yC3";
export var wrapper = "Highlight-module--wrapper--Wm+eS";